import { MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import React from "react";
import classes from "./ContactCodeModal.module.scss";

type ContactCodeModalProps = {
  /** モーダルの展開状態 */
  isOpen: boolean;
  /** 問合せコード */
  code: string;
  /** 問い合わせリンク */
  contactUrl: string;
  /** 閉じるボタン押下時の処理 */
  onCloseClick: () => void;
};

const ContactCodeModal: React.FC<ContactCodeModalProps> = (props) => {
  return (
    <MDBModal isOpen={props.isOpen} toggle={() => {}} centered>
      <MDBModalHeader toggle={props.onCloseClick}>
        <span className={classes.title}>お問い合わせについて</span>
      </MDBModalHeader>
      <MDBModalBody className="py-4">
        <div className={`mb-3 text-center ${classes.hintText}`}>
          お問い合わせの際は、
          <br className="d-sm-none" />
          下記コードを入力してください
        </div>
        <div className={`my-2 text-center ${classes.code}`}>{props.code}</div>
        <div className={`mt-3 text-center ${classes.hintText}`}>
          お問い合わせは
          <a
            href={props.contactUrl}
            className="mx-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            こちら
          </a>
        </div>
      </MDBModalBody>
    </MDBModal>
  );
};

export default ContactCodeModal;
